import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Bell(props) {
  const { fillColor = "#000000" } = props;
  return (
    <Svg width={24} height={24} viewBox="0 0 700 820" {...props}>
      <Path
        d="M579 372q0 24 9 45t25 37 37 25 45 9v93H0v-93q24 0 45-9t37-25 25-37 9-45V233q0-48 18-90t50-74 73-50 90-18 90 18 74 50 50 74 18 90v139zM347 696q-32 0-56-20t-33-49h179q-8 30-32 49t-58 20z"
        fill={fillColor}
      />
    </Svg>
  );
}

export default Bell;
